import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import '@coreui/coreui/dist/css/coreui.min.css'
import {
  CButton,
  CCloseButton,
  CContainer,
  CNavbar,
  CNavbarBrand,
  CNavbarNav,
  CNavbarToggler,
  CNavItem,
  CNavLink,
  COffcanvas,
  COffcanvasBody,
  COffcanvasHeader,
  CDropdown,
  CDropdownMenu,
  CDropdownItem,
  CDropdownToggle
} from '@coreui/react';
import { useAuth } from '../contexts/authContext';
import { signOutUser } from '../firebase/auth';

function NavBar() {
  const navigate = useNavigate();
  const { currentUser, role } = useAuth();
  const location = useLocation();
  const [visible, setVisible] = useState(false)
  const onLogout = () => {
    signOutUser();
    navigate('/');
  }

  return (
    <CNavbar className='navbar'>
      <CContainer fluid className='navbar-container'>




        {currentUser && role === "shelter" ? (
          <CNavbarBrand> <a href='/' className='pawtner'><img className='logo' src='/PawtnerLogo.png' alt='Pawtner Logo' to='/' /> Pawtner </a></CNavbarBrand>
        )
          :
          (<>
            <CNavbarBrand> <a href='/' className='pawtner'><img className='logo' src='/PawtnerLogo.png' alt='Pawtner Logo' to='/' /> Pawtner </a></CNavbarBrand>
            <Link to='/' className={`link ${location.pathname === "/" ? "active" : ""}`}> Home </Link>
            <Link to='/adopt' className={`link ${location.pathname === "/adopt" ? "active" : ""}`}> Adopt Your Pet </Link>
            <Link to='/chatbot' className={`link ${location.pathname === "/chatbot" ? "active" : ""}`}> Chatbot </Link>
            <Link to='/lost-found' className={`link ${location.pathname === "/lost-found" ? "active" : ""}`}> Lost and Found </Link>
            <Link to='/about-us' className={`link ${location.pathname === "/about-us" ? "active" : ""}`}> About Us </Link>
          </>
          )}

        {currentUser && (role === "adopter" || role === "shelter") ? (
          <CDropdown>
            <CDropdownToggle style={{
              border: "none", fontSize: "15px", padding: "0 5px", whiteSpace: "nowrap",
              overflow: "hidden", textOverflow: "ellipsis"
            }}>{currentUser.displayName
              ? currentUser.displayName.split(" ").slice(0, 3).join(" ") +
              (currentUser.displayName.split(" ").length > 3 ? "..." : "")
              : ""}</CDropdownToggle>

            {currentUser && role === "adopter" ? (
              <CDropdownMenu style={{border:"none"}}>
                <CDropdownItem href='/profile'>Profile</CDropdownItem>
                <CDropdownItem href='/my-applications'>My Applications</CDropdownItem>
                <CDropdownItem href='/my-posts'>My Posts</CDropdownItem>
                <CDropdownItem onClick={onLogout} >Logout</CDropdownItem>
              </CDropdownMenu>
            ) : (<CDropdownMenu>
              <CDropdownItem href='/shelter-profile'>Profile</CDropdownItem>
              <CDropdownItem onClick={onLogout} >Logout</CDropdownItem>
            </CDropdownMenu>)}
          </CDropdown>)
          : (
            <CButton href='/login' className='signInBtn' variant="outline">
              Sign In
            </CButton>
          )}


        {currentUser && role === "shelter" ? <></> : (<>
          <CNavbarToggler
            className="menu-toggle"
            aria-controls="offcanvasNavbar"
            aria-label="Toggle navigation"
            onClick={() => setVisible(!visible)}
          />
          <COffcanvas
            id="offcanvasNavbar"
            placement="end"
            portal={false}
            visible={visible}
            onHide={() => setVisible(false)}
            style={{ width: '250px' }}
          >
            <COffcanvasHeader>
              <CCloseButton className="text-reset" onClick={() => setVisible(false)} />
            </COffcanvasHeader>
            <COffcanvasBody>
              <CNavbarNav style={{ display: 'flex', flexDirection: 'column' }}>
                <CNavItem >
                  <CNavLink href="/" className={location.pathname === "/" ? "active" : ""}>
                    Home
                  </CNavLink>
                </CNavItem>
                <CNavItem>
                  <CNavLink href="/adopt" className={location.pathname === "/adopt" ? "active" : ""}>
                    Adopt Your Pet</CNavLink>
                </CNavItem>
                <CNavItem>
                  <CNavLink href="/chatbot" className={location.pathname === "/chatbot" ? "active" : ""}>
                    Chatbot
                  </CNavLink>
                </CNavItem>
                <CNavItem>
                  <CNavLink href="/lost-found" className={location.pathname === "/lost-found" ? "active" : ""}>
                    Lost and Found
                  </CNavLink>
                </CNavItem>
                <CNavItem>
                  <CNavLink href="/about-us" className={location.pathname === "/about-us" ? "active" : ""}>
                    About Us
                  </CNavLink>
                </CNavItem>
              </CNavbarNav>
            </COffcanvasBody>
          </COffcanvas>
        </>
        )}
      </CContainer>
    </CNavbar>
  )


}

export default NavBar;
